import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CommunicationsService, Communication, CommunicationRecipient } from '../../../../services/communications.service';

@Component({
  selector: 'app-communication-info-modal',
  templateUrl: './communication-info-modal.component.html',
  styleUrls: ['./communication-info-modal.component.scss']
})
export class CommunicationInfoModalComponent implements OnInit, OnDestroy {

  @ViewChild('modal', { static: false }) private modalContent: TemplateRef<CommunicationInfoModalComponent>
  private modalRef: NgbModalRef;

  private communication: Communication;

  private showExtraEmails: boolean = false;

  unsubscribe: Subject<any> = new Subject();

  constructor(
    private modalService: NgbModal,
    private communicationService: CommunicationsService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  communicationRecipientNames(communicationRecipients: Array<CommunicationRecipient>): string {
    return communicationRecipients.map(cr => cr.recipientName).join(", ");
  }

  open(communicationId: number): Promise<any> {
    this.communication = null;
    this.communicationService.getCommunication(communicationId);
    this.communicationService.communication
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(communication => {
        if (communication) {
          this.communication = communication;
        }
      });
    this.modalRef = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    return this.modalRef.result;
  }

  async close() {
    this.modalRef.close(true);
  }

  async dismiss() {
    this.modalRef.dismiss('X');
  }

}
